<ng-template [ngIf]="loadingService.isLoading$ | async">
  <div class="loader-full">
    <div class="lds-ring">
      <img width="40" height="40" src="../../../assets/svg/icon-spinner.svg">
    </div>
    <p class="loading-text" *ngIf="loadingService.loadingMessage$ | async as msg" [innerHTML]="msg"></p>

  </div>
</ng-template>
